import React from "react";
import Container from "../../components/Container/Container";
import { Col } from "react-bootstrap";

const HaircareProducts = () => {
  return (
    <Container>
      <Col>
      <h1>Haircare</h1>
      </Col>
    </Container>
  );
};

export default HaircareProducts;
